/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Can_CloseInputs */

const en_import_can_close = /** @type {(inputs: Import_Can_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can close this: imports keep running.`)
};

const de_import_can_close = /** @type {(inputs: Import_Can_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst das schließen: Importe laufen weiter.`)
};

/**
* | output |
* | --- |
* | "You can close this: imports keep running." |
*
* @param {Import_Can_CloseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_can_close = /** @type {((inputs?: Import_Can_CloseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Can_CloseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_can_close(inputs)
	return en_import_can_close(inputs)
});